<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>实验管理</el-breadcrumb-item>
      <el-breadcrumb-item>实验列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <div class="filter">
        <el-form
          label-position="right"
          class="search-form"
          label-width="80px"
          inline
          size="small"
          @submit.native.prevent
        >
          <el-form-item label="实验人">
            <el-input
              size="small"
              v-model="filter.experimenter"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="单号">
            <el-input
              size="small"
              v-model="filter.order_number"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="钻具类型">
            <el-input
              size="small"
              v-model="filter.drill_tool_category"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="实验日期" prop="date">
            <el-date-picker
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div style="margin-left: 80px">
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData(false)
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </div>
      </div>
    </div>
    <div class="panel">
      <el-button
        size="small"
        type="primary"
        v-code="91101"
        @click="$router.push('/experiment/experiments/new')"
        >添加实验</el-button
      >
      <ListTable :list="list"></ListTable>
      <el-pagination
        background
        class="m-t-20 text-right"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData(false)"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { experimentList } from '../../../service/getData'
import ListTable from './_table.vue'
export default {
  components: {
    ListTable,
  },
  data() {
    return {
      filter: {
        page: 1,
        size: 10,
        date: '',
        experimenter: '',
        order_number: '',
        drill_tool_category: '',
      },
      total: 0,
      list: [],
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.date = ''
        this.filter.experimenter = ''
        this.filter.order_number = ''
        this.filter.drill_tool_category = ''
      }

      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let params = this.clone(this.filter)
      params.page -= 1
      if (params.date && params.date.length == 2) {
        params.start_date = params.date[0]
        params.end_date = params.date[1]
      }
      let res = await experimentList(params)
      this.list = res.data.list
      this.total = res.data.count
    },
  },
}
</script>